import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d46388a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "inputs-divider" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "inputs-divider" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import { IonGrid, IonRow, IonPage, IonHeader,IonToolbar, IonContent, IonImg } from '@ionic/vue';
import PgsSavings from '@/components/PgsSavings.vue';
import PgsInfo from '@/components/PgsInfo.vue';
import PgsInputFill from '@/components/PgsInputFill.vue';

import { reactive, computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'KalkulatorView',
  setup(__props) {

const income = ref(0);

const stateRed:any = reactive({
  kwotaOplat: 0,
  calcProwizja: computed (() => {
    // działanie: "kwota opłat" x 100 : "obrót" = "prowizja w %"
    const calc = (stateRed.kwotaOplat * 100) / (income.value || 1)
    return !isNaN(calc) ? calc.toFixed(2) + ' %' : '--'
  }),
})

const stateGreen:any = reactive({
  prowizja: 0, // Podawane w %
  kwotaOplat: computed (() => {
    // działanie- "obrót" x "prowizja w %" = "kwota opłat"
    const calc = income.value * ( stateGreen.prowizja / 100 )
    return !isNaN(calc) ? calc.toFixed(2) : 0
  }),
})

const savings:any = reactive({
  monthly: computed (() => {
    // Róznica pomiędzy starymi a nowymi opłatami
    return stateRed.kwotaOplat - stateGreen.kwotaOplat
  }),
  annualy: computed (() => {
    return savings.monthly * 12
  }),
  
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { class: "pgs-toolbar" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonImg), {
                class: "logo-image-top",
                src: "./assets/icon/logo-full-wide.jpeg"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { class: "inputs-grid" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(PgsInputFill, {
                    label: "Obrót miesięczny (zł)",
                    modelValue: income.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((income).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_1,
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(PgsInputFill, {
                    label: "Kwota opłat miesięcznie (zł)",
                    modelValue: stateRed.kwotaOplat,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((stateRed.kwotaOplat) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(PgsInfo, {
                    label: "Prowizja",
                    type: "red",
                    info: stateRed.calcProwizja
                  }, null, 8, ["info"])
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(PgsInputFill, {
                    label: "Nowa prowizja (%)",
                    modelValue: stateGreen.prowizja,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stateGreen.prowizja) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(PgsInfo, {
                    label: "Kwota opłat miesięcznie",
                    type: "green",
                    info: `${stateGreen.kwotaOplat} zł`
                  }, null, 8, ["info"])
                ]),
                _: 1
              }),
              _hoisted_3,
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(PgsSavings, {
                    savings: savings.monthly
                  }, null, 8, ["savings"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})